const local = window.location.pathname.split("/")[1];

function onWidgetReady(selector, callback) {
  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) {
      observer.disconnect();
      callback(el);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

onWidgetReady(
  ".rebuy-cart__flyout [data-rebuy-cart-anchor='footer']",
  (element) => {
    const fr = {
      blocks: [
        {
          section: "flyout-installments",
          selector: ".rebuy-cart__flyout-installments",
          translations: {
            text: "Ou 12 paiements sans intérêts de <XXX> avec",
          },
        },
        {
          section: "cart",
          selector: ".rebuy-cart__flyout-subtotal-label",
          translations: {
            text: "Sous-total",
          },
        },
        {
          section: "cart",
          selector: ".rebuy-button.rebuy-cart__checkout-button.block",
          translations: {
            text: "Passer à la caisse",
          },
        },
      ],
    };

    switch (local) {
      case "fr":
        fr.blocks.forEach((block) => {
          const element = document.querySelector(block.selector);
          switch (block.section) {
            case "flyout-installments":
              changeInstallmentText(element, block.translations.text);
              break;
            case "cart":
              translateText(element, block.translations.text);
              break;
            default:
              break;
          }
        });
        break;
      default:
        break;
    }
  }
);

function changeInstallmentText(element, text) {
  const currentText = element.textContent;
  const old = element.cloneNode(true);
  const regex = /\$\d{1,3}(,\d{3})*(\.\d{2})?/;
  const match = currentText.match(regex);
  if (match) {
    const amount = match[0];
    const newText = text.replace("<XXX>", amount);
    element.textContent = newText;
    element.appendChild(old.querySelector("a").cloneNode(true));
  }
}

function translateText(element, text) {
  if (element) {
    element.textContent = text;
  }
}

const translateFR = [
  {
    action: "translate",
    selector: "#beam-SelectNonprofit-title",
    translations: {
      text: "Choisissez votre cause",
    },
  },
  {
    action: "translate",
    selector: ".description",
    translations: {
      text: "Choisissez un organisme à but non lucratif et 1% lui sera versé en votre nom, sans frais supplémentaires.",
    },
  },
];

function deepCollectFromRoot(root) {
  const out = [];

  const walk = (node) => {
    if (!node) return;

    if (node.querySelectorAll) {
      out.push(...node.querySelectorAll("*"));
    }

    if (node.shadowRoot) {
      walk(node.shadowRoot);
    }

    const slots = node.querySelectorAll ? node.querySelectorAll("slot") : [];
    for (const s of slots) {
      const assigned = s.assignedElements({ flatten: true });
      for (const a of assigned) {
        out.push(a);
        walk(a);
      }
    }
  };

  walk(root instanceof ShadowRoot ? root : root);
  return Array.from(new Set(out));
}

function deepQuerySelectorAll(root, selector) {
  const results = [];
  const seen = new Set();

  const add = (el) => {
    if (el && !seen.has(el)) {
      seen.add(el);
      results.push(el);
    }
  };

  const walk = (node) => {
    if (!node) return;

    if (node.querySelectorAll) {
      node.querySelectorAll(selector).forEach(add);
    }

    if (node.shadowRoot) {
      walk(node.shadowRoot);
    }

    const slots = node.querySelectorAll ? node.querySelectorAll("slot") : [];
    for (const s of slots) {
      const assigned = s.assignedElements({ flatten: true });
      for (const a of assigned) {
        if (a.matches && a.matches(selector)) add(a);
        if (a.querySelector) a.querySelectorAll(selector).forEach(add);
        // También seguir bajando por si este asignado tiene shadow root
        if (a.shadowRoot) walk(a.shadowRoot);
      }
    }
  };

  walk(root);
  return results;
}

function exposeBeamCollection(host) {
  const root = host.shadowRoot || host;
  const collect = () => deepCollectFromRoot(root);

  window.beamSelectNonprofit = {
    host,
    root,
    get all() {
      return collect();
    },
    bySelector(sel) {
      return deepQuerySelectorAll(root, sel);
    },
    refresh() {
      return collect();
    },
  };

  console.log(window.beamSelectNonprofit);

  translateFR.map((block) => {
    const element = window.beamSelectNonprofit.bySelector(block.selector)[0];
    if (element) {
      element.textContent = block.translations.text;
    }
  });

  const cloneOptions = window.beamSelectNonprofit
    .bySelector(".options")[0]
    .cloneNode(true);
  const options = window.beamSelectNonprofit
    .bySelector(".options")[0]
    .querySelectorAll(".option");
  if (options) {
    const details = window.beamSelectNonprofit.bySelector(".details")[0];
    options.forEach((opt, index) => {
      opt.addEventListener("click", () => {
        switch (index) {
          case 0:
            details.querySelector(".details-cause").textContent =
              "Santé mentale";
            details.querySelector(".details-impactDescription").textContent =
              "Fonds permettant à trois personnes de ne plus être sur une liste d'attente pour recevoir des soins de santé mentale. via Canadian Mental Health Association";
            details.querySelector(
              ".details-fundingProgressLabel"
            ).textContent = `36% financé`;
            break;
          case 1:
            details.querySelector(".details-cause").textContent =
              "Développement durable";
            details.querySelector(".details-impactDescription").textContent =
              "Financer la plantation de 200 arbres pour restaurer les forêts du Québec détruites par les feux de forêt. via Tree Canada";
            details.querySelector(
              ".details-fundingProgressLabel"
            ).textContent = `17% financé`;
            break;
          case 2:
            details.querySelector(".details-cause").textContent =
              "Aide aux personnes handicapées";
            details.querySelector(".details-impactDescription").textContent =
              "Financer le remplacement d'un pneu d'un vélo à main appartenant à un athlète handicapé. via Achilles International";
            details.querySelector(
              ".details-fundingProgressLabel"
            ).textContent = `10% financé`;
            break;
          default:
            break;
        }
        details.querySelector(".details-beamAttribution").textContent =
          "Optimisé par Beam";
      });
    });

    options[0].click();
  }
}

onWidgetReady("beam-select-nonprofit", (el) => {
  if (local == "fr") {
    const start = Date.now();
    const poll = setInterval(() => {
      const root = el.shadowRoot || el;
      if (root) {
        clearInterval(poll);
        exposeBeamCollection(el);

        const toObserve = el.shadowRoot || el;
        try {
          const obs = new MutationObserver(() => {
            console.debug(
              "🔁 beam-select-nonprofit DOM changed, refreshing window.beamSelectNonprofit.all"
            );
          });
          obs.observe(toObserve, { childList: true, subtree: true });
          setTimeout(() => obs.disconnect(), 60000);
        } catch (e) {
          console.warn("Failed to observe beam-select-nonprofit:", e);
        }
      }

      if (Date.now() - start > 10000) {
        clearInterval(poll);
        exposeBeamCollection(el);
      }
    }, 100);
  }
});
